import { toTitleCase } from "@/lib/utils";
import type { ActiveFiltersProps } from "./types";

export function ActiveFilters({
  artists,
  selectedArtistIds,
  selectedTags,
  selectedTag,
  onRemoveArtist,
  onRemoveTag,
  onClear,
  onClearParentTag,
}: ActiveFiltersProps) {
  const hasFilters = selectedArtistIds.length > 0 || selectedTags.length > 0 || selectedTag;

  if (!hasFilters) return null;

  return (
    <div className="flex justify-center items-center gap-2 mb-6 flex-wrap">
      <span className="text-sm text-[var(--color-text-muted)]">Active filters:</span>

      {selectedArtistIds.map((id) => {
        const artist = artists.find((a) => a.id === id);
        return artist ? (
          <span
            key={id}
            className="inline-flex items-center gap-1 px-3 py-1 bg-[var(--color-primary)]/20 border border-[var(--color-primary)] rounded-full text-sm text-[var(--color-primary)]"
          >
            {artist.name}
            <button
              onClick={() => onRemoveArtist(id)}
              className="ml-1 hover:text-white transition-colors"
              aria-label={`Remove ${artist.name} filter`}
            >
              ×
            </button>
          </span>
        ) : null;
      })}

      {selectedTags.map((tag) => (
        <span
          key={tag}
          className="inline-flex items-center gap-1 px-3 py-1 bg-[var(--color-primary)]/20 border border-[var(--color-primary)] rounded-full text-sm text-[var(--color-primary)]"
        >
          {toTitleCase(tag)}
          <button
            onClick={() => onRemoveTag(tag)}
            className="ml-1 hover:text-white transition-colors"
            aria-label={`Remove ${toTitleCase(tag)} filter`}
          >
            ×
          </button>
        </span>
      ))}

      {selectedTag && !selectedTags.includes(selectedTag) && (
        <span className="inline-flex items-center gap-1 px-3 py-1 bg-[var(--color-primary)]/20 border border-[var(--color-primary)] rounded-full text-sm text-[var(--color-primary)]">
          {toTitleCase(selectedTag)}
          {onClearParentTag && (
            <button
              onClick={onClearParentTag}
              className="ml-1 hover:text-white transition-colors"
              aria-label={`Remove ${toTitleCase(selectedTag)} filter`}
            >
              ×
            </button>
          )}
        </span>
      )}

      <button
        onClick={onClear}
        className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-primary)] underline transition-colors"
      >
        Clear all
      </button>
    </div>
  );
}
